import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppRouter } from './router/AppRouter';
import CookieBanner from './components/CookieBanner';
import './index.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <CookieBanner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
